import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { DatePicker } from 'material-ui-pickers';

import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { AddButton } from 'components/core';
import { Section } from '../../ContentEdit';
import { BusinessLogo } from '../../../Logo';
import { ClientDialog } from 'components/admin/Dialogs';
import { startEditBid } from '../../../../store/actions/bids';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifycontent: 'space-between',

  },
  content: {
    flexGrow: 1,
    marginTop: theme.spacing.unit*3,
    marginLeft: theme.spacing.unit*3,
  },
  side: {
    maxWidth: '250px',
    display: 'flex',
    flexDirection: 'column',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  date: {
    flexGrow: 1,
  },
  client: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing.unit*2,
  },
  clientWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  formControl: {
    margin: theme.spacing.unit,
  },
  address: {
    marginTop: theme.spacing.unit*2,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  left: {
    width: '50px',
  },
  right: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexGrow: 1,
  },
  clientSelect: {
    width: '200px',
  },
});

class GeneralInfo extends Component {
  constructor(props){
    super(props);
    this.state = { showAddClient: false };
  }

  render() {
    const {
      classes,
      heading,
      bid,
      preview,
      clients,
      help,
      bidValidation,
      showValidation,
      startEditBid,
      startEditBidEditorState
    } = this.props;
    const { showAddClient } = this.state;
    const { showHeader = false } = bid.template;

    return(
      <div>
        <ClientDialog
          show={showAddClient}
          handleCreated={(result) => {
            startEditBid(bid.id, { clientId: result });
          }}
          handleClose={() => this.setState({ showAddClient: false })}
        />
        <Section
          preview={preview}
          title="General Information"
          showContent={showHeader}
          showAdd={false}>
          <div className={classes.root} >
            <div className={classes.content}>
              <BusinessLogo title="Landscaping done right" />
            </div>
            <div className={classes.side}>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <Typography variant="display3">
                    {heading}
                  </Typography>
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <Typography variant="subheading">Ref #:</Typography>
                  <Typography variant="subheading">{bid.bidNumber}</Typography>
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <DatePicker
                      disabled={preview}
                      className={classes.date}
                      label="Date"
                      format="MMMM Do YYYY"
                      value={bid.date}
                      leftArrowIcon={<ArrowBackIcon />}
                      rightArrowIcon={<ArrowForwardIcon />}
                      onFocus={() => startEditBidEditorState("generalDate")}
                      onChange={(date) => startEditBid(bid.id, {date: date.toDate().getTime()})}
                    />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <DatePicker
                      disabled={preview}
                      className={classes.date}
                      label="Expires"
                      format="MMMM Do YYYY"
                      value={bid.dueDate}
                      leftArrowIcon={<ArrowBackIcon />}
                      rightArrowIcon={<ArrowForwardIcon />}
                      onFocus={() => startEditBidEditorState("generalExpires")}
                      onChange={(date) => startEditBid(bid.id, {dueDate: date.toDate().getTime()})}
                    />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left}>
                  <Tooltip type={TooltipTypes.bid.ADD_CLIENT} placement="left">
                    <AddButton
                      elevate={help.isCurrentStep(TooltipTypes.bid.ADD_CLIENT)}
                      onClick={() => {
                        helpDispatch(TooltipTypes.bid.ADD_CLIENT);
                        this.setState({ showAddClient: true });
                      }}
                    />
                  </Tooltip>
                </div>
                <div className={classes.right}>
                  <FormControl
                    error={ showValidation ? !!bidValidation.validateField("clientId") : false }
                    style={{margin: '0px'}}
                    className={classes.clientSelect}>
                    <InputLabel htmlFor="client-simple">Client</InputLabel>
                    <Select
                      disabled={preview}
                      value={bid.clientId === undefined ? "" : bid.clientId}
                      onFocus={() => startEditBidEditorState("generalClient")}
                      onChange={(event) => {
                        startEditBid(bid.id, { [event.target.name]: event.target.value })
                      }}
                      inputProps={{
                        name: 'clientId',
                        id: 'client-simple',
                      }}
                    >
                      {clients &&
                        clients.map((client, i) => {
                          return <MenuItem key={i} value={client.id}>{`${client.lastName}, ${client.firstName}`}</MenuItem>
                        })
                      }
                    </Select>
                    {showValidation && bidValidation.validateField("clientId") &&
                      <FormHelperText>{bidValidation.validateField("clientId")}</FormHelperText>
                    }
                  </FormControl>
                </div>
              </div>
            </div>
          </div>
        </Section>
      </div>
    );
  }
}

// const GeneralInfo = (props) => {
//   const {
//     classes,
//     heading,
//     bid,
//     preview,
//     clients,
//     client,
//     bidValidation,
//     showValidation,
//     startEditBid,
//     startEditBidEditorState
//   } = props;
//   const { showHeader = false } = bid.template;
//
//   return(
//     <div>
//       <Section
//         preview={preview}
//         title="General Information"
//         showContent={showHeader}
//         showAdd={false}>
//         <div className={classes.root} >
//           <div className={classes.content}>
//             <BusinessLogo title="Landscaping done right" />
//           </div>
//           <div className={classes.side}>
//             <div className={classes.row}>
//               <div className={classes.left} />
//               <div className={classes.right}>
//                 <Typography variant="display3">
//                   {heading}
//                 </Typography>
//               </div>
//             </div>
//             <div className={classes.row}>
//               <div className={classes.left} />
//               <div className={classes.right}>
//                 <Typography variant="subheading">Ref #:</Typography>
//                 <Typography variant="subheading">{bid.bidNumber}</Typography>
//               </div>
//             </div>
//             <div className={classes.row}>
//               <div className={classes.left} />
//               <div className={classes.right}>
//                 <DatePicker
//                     disabled={preview}
//                     className={classes.date}
//                     label="Date"
//                     format="MMMM Do YYYY"
//                     value={bid.date}
//                     leftArrowIcon={<ArrowBackIcon />}
//                     rightArrowIcon={<ArrowForwardIcon />}
//                     onFocus={() => startEditBidEditorState("generalDate")}
//                     onChange={(date) => startEditBid(bid.id, {date: date.toDate().getTime()})}
//                   />
//               </div>
//             </div>
//             <div className={classes.row}>
//               <div className={classes.left} />
//               <div className={classes.right}>
//                 <DatePicker
//                     disabled={preview}
//                     className={classes.date}
//                     label="Expires"
//                     format="MMMM Do YYYY"
//                     value={bid.dueDate}
//                     leftArrowIcon={<ArrowBackIcon />}
//                     rightArrowIcon={<ArrowForwardIcon />}
//                     onFocus={() => startEditBidEditorState("generalExpires")}
//                     onChange={(date) => startEditBid(bid.id, {dueDate: date.toDate().getTime()})}
//                   />
//               </div>
//             </div>
//             <div className={classes.row}>
//               <div className={classes.left}>
//                 <AddButton
//                   onClick={() => console.log("TEST")}
//                 />
//               </div>
//               <div className={classes.right}>
//                 <FormControl
//                   error={ showValidation ? !!bidValidation.validateField("clientId") : false }
//                   style={{margin: '0px'}}
//                   className={classes.clientSelect}>
//                   <InputLabel htmlFor="client-simple">Client</InputLabel>
//                   <Select
//                     disabled={preview}
//                     value={bid.clientId === undefined ? "" : bid.clientId}
//                     onFocus={() => startEditBidEditorState("generalClient")}
//                     onChange={(event) => {
//                       startEditBid(bid.id, { [event.target.name]: event.target.value })
//                     }}
//                     inputProps={{
//                       name: 'clientId',
//                       id: 'client-simple',
//                     }}
//                   >
//                     {clients &&
//                       clients.map((client, i) => {
//                         return <MenuItem key={i} value={client.id}>{`${client.lastName}, ${client.firstName}`}</MenuItem>
//                       })
//                     }
//                   </Select>
//                   {showValidation && bidValidation.validateField("clientId") &&
//                     <FormHelperText>{bidValidation.validateField("clientId")}</FormHelperText>
//                   }
//                 </FormControl>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Section>
//     </div>
//
//   );
// };

GeneralInfo.defaultProps = {
  bid: {
    template: {}
  }
};


const mapStateToProps = (state) => {
  const { id: bidId, showValidation } = state.adminState.bid;
  const bid = state.bidsState.find( bid => bid.id === bidId );
  const clients = state.clientsState;
  const client = bid === undefined ? undefined : clients.find((client) => client.id === bid.clientId);
  const bidValidation = state.validation.bids.find(item => item.id === bid.id);
  return {
    bid: bid,
    clients: clients,
    client: client,
    bidValidation,
    showValidation,
    help: state.help,
  }
};

const mapDispatchToProps = (dispatch) => ({
  startEditBid: (bidId, bid) => dispatch(startEditBid(bidId, bid)),
  startEditBidEditorState: (key) => dispatch(startEditBidEditorState(key)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(GeneralInfo);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/GeneralInfo.jsx